import { isOrientedTarget } from '@utils/map/map.utils';
import {
  getContingencyIcon,
  getTargetIconName,
  getTargetIdentification,
  getTargetRotation,
  isSure,
} from '@utils/target.utils';
import { toLonLatArray } from '@utils/validation/coordinates.utils';
import { Feature } from 'geojson';

import { Target } from '@/types/c2/c2.types';
import { Coordinates } from '@/types/commons/commons.types';
import { FeatureTypeEnum } from '@/types/map.types';
import { TargetLocation } from '@/types/sensor/sensor.types';

export function toEngagedTargetIconFeature(target: Target<TargetLocation>, organization: string | null): Feature {
  const shouldBeOriented = isOrientedTarget(target, organization) && isSure(target);
  return {
    type: 'Feature',
    id: `${FeatureTypeEnum.ENGAGED_TARGET_ICON}-${target.id}`,
    properties: {
      id: target.id,
      featureType: FeatureTypeEnum.ENGAGED_TARGET_ICON,
      value: target,
      identification: getTargetIdentification(target, organization),
      icon: getTargetIconName(target, organization),
      contingencyIcon: getContingencyIcon(target, organization),
      ...(shouldBeOriented ? { heading: getTargetRotation(target, organization) } : {}),
    },
    geometry: {
      type: 'Point',
      coordinates: toLonLatArray(target.lastPosition.location!.position, false),
    },
  } as Feature;
}

export function toEngagementCircleFeature(position: Coordinates): Feature {
  return {
    type: 'Feature',
    id: 'engagement-circle',
    properties: {
      id: 'engagement-circle',
      featureType: FeatureTypeEnum.ENGAGEMENT_CIRCLE,
      value: null,
      icon: 'icSymb-L-neutral',
    },
    geometry: {
      type: 'Point',
      coordinates: toLonLatArray(position, false),
    },
  } as Feature;
}
